import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Actions from "./Actions";
import MessageToSend from "./MessageToSend";
import Title from "./Title";

const CreateOneOOneM = withLiteObserverAndTheme(() => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Title />
        <MessageToSend />
        <Actions />
      </Stack>
    </Paper>
  );
});

export default CreateOneOOneM;
